import {
  Button, Card,
  CardActions,
  CardContent, CircularProgress, Container, Dialog, DialogActions,
  DialogContent, DialogContentText, DialogTitle, Divider,
  Typography
} from '@material-ui/core';
import CropFreeIcon from '@material-ui/icons/CropFree';
import logger from 'src/utils/logger';

import SendIcon from '@material-ui/icons/Send';
import { makeStyles } from '@material-ui/styles';
import React, { useState } from 'react';
import Header from 'src/components/Header';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import { default as BarkodPopup, default as QrBarkodPopup } from '../../components/BarcodePopup';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  },
  contentMaterialImage: {
    padding: 0,
    minHeight: 380,
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  submitMaterialImage: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
}));

function QrBarcodeMap() {
  const classes = useStyles();
  const [UrunBarkod, setUrunBarkod] = useState('');
  const [QrBarkod, setQrBarkod] = useState('');
  const [openBarkod, setOpenBarkod] = useState(false);
  const [openQrBarkod, setOpenQrBarkod] = useState(false);
  const [loading, setLoading] = useState(false);
  const [Uyari, setUyari] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const SessionUser = getUser();

  const handleClose = () => {
    setOpen(false);
  };



  const SendMaterialImageDetail = () => {
    if (UrunBarkod === '') {
      setUyari("Lütfen Ürün barkod etiketini okutunuz!...");
      setOpen(true);
      return;
    }
    if (QrBarkod === '') {
      setUyari("Lütfen QR etiketini okutunuz!...");
      setOpen(true);
      return;
    }

    axios.get(`/SetQrCodeMap/${UrunBarkod}/${QrBarkod}/${SessionUser?.OrganizationUserId}`)
      .then(() => {
        setUyari("İşleminiz başarı ile gerçekleştirildi...");
        setUrunBarkod('');
        setQrBarkod('');
        setOpen(true);
        setLoading(false);
      }).catch(error => {
        setLoading(false);
              logger.error("Hata detayı:", error.message);
      });
  }



  const handleBarkodClose = async (barkod) => {
    setOpenBarkod(false);
    if (barkod && typeof barkod.length !== 'undefined') {
      setUrunBarkod(barkod);
    }
  }
  const handleQrBarkodClose = async (barkod) => {
    setOpenQrBarkod(false);
    if (barkod && typeof barkod.length !== 'undefined') {
      setQrBarkod(barkod);
    }
  }

  return (
    <Page className={classes.root} title="Malzeme Fotoğraf Eşleme">
      <Container maxWidth="lg">
        <Header />
        <Card>
          {loading && <CircularProgress
            status={'loading'}
            style={{ marginLeft: '50%' }}
          />}
          <CardActions>
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              onClick={() => setOpenBarkod(true)}
              endIcon={<CropFreeIcon />}>
              Scandit Barcode
            </Button>
            {/* <Button
              variant="contained"
              color="secondary"
              fullWidth
              onClick={() => setOpenBarkodScanbot(true)}
              endIcon={<CropFreeIcon />}>
              Scanbod Barcode
            </Button> */}
          </CardActions>
          <Divider />
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Ürün Barkod: {UrunBarkod}
            </Typography>
          </CardContent>
          <Divider />
          <CardActions>
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              onClick={() => setOpenQrBarkod(true)}
              endIcon={<CropFreeIcon />}>
              QR Kod Oku
            </Button>
          </CardActions>
          <Divider />
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Qr Barkod: {QrBarkod}
            </Typography>
          </CardContent>
          <Divider />
          <CardActions>
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              onClick={SendMaterialImageDetail}
              endIcon={<SendIcon />}>
              Eşleme Yap
            </Button>
          </CardActions>
          <Divider />
        </Card>
      </Container>
      <BarkodPopup
        onClose={handleBarkodClose}
        open={openBarkod}
        ScanTime={0}
        CallScreen={0}
      />
      {/* <BarkodPopupScanbot
        onClose={handleBarkodCloseScanbot}
        open={OpenBarkodScanbot}
        ScanTime={0}
        CallScreen={0}
      /> */}




      <QrBarkodPopup
        onClose={handleQrBarkodClose}
        open={openQrBarkod}
        ScanTime={0}
        CallScreen={0}
      />

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description" >
        <DialogTitle id="alert-dialog-slide-title" color="primary">{"Bilgilendirme"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}

export default QrBarcodeMap;
